// TokenContext.js
import React, { createContext, useMemo, useState } from 'react';

export const TokenContext = createContext();

export function TokenProvider({ children }) {
  const [purchaseIntent, setPurchaseIntent] = useState(0);     // tokens qty
  const [planIntent, setPlanIntent] = useState(null);          // "Starter" | "Growth" | ...

  const [balance, setBalance] = useState(0);

  const value = useMemo(() => ({
    purchaseIntent, setPurchaseIntent,
    planIntent, setPlanIntent,
    balance, setBalance,
  }), [purchaseIntent, planIntent, balance]);

  return <TokenContext.Provider value={value}>{children}</TokenContext.Provider>;
}
